import { createSlice } from "@reduxjs/toolkit";


const updateSlice = createSlice({
    name: "updateSymbol",
    initialState: {
        symbols: {}
    },
    reducers: {
        updateSymbols: (state, action) => {
            state.symbols = action.payload
        }
    }
})

export const { updateSymbols } = updateSlice.actions;

export default updateSlice.reducer;